<template>
<div class="xzsyCon3 sygl" id="form_dialog">
    <div class="fctop">
        <h3>供样信息</h3>
    </div>
    <div class="fcbtm">
        <div class="left_nav">
            <form action="#">
                <ul>
                    <li>
                        <div class="t" :class="{hover: keys[0]}" @click="blockToggle(0)"><i>产品信息</i></div>
                        <div class="txt" v-show="!keys[0]">
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>索样产品： </span>
                                </div>
                                <div class="zsxq-right">
                                    <textarea name="productName2" placeholder="请描述索样产品" v-model="goodsName" readonly></textarea>
                                </div>
                            </div>
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>应用领域： </span>
                                </div>
                                <div class="zsxq-right">
                                    <input type="text" name="application_area" placeholder="请填写产品应用领域，如：风电涂料，3C涂料" v-model="application" readonly/>
                                </div>
                            </div>
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span>品质要求： </span>
                                </div>
                                <div class="zsxq-right">
                                    <input type="text" name="quality" placeholder="请填写品质需求，如：纯度99.9%，工业级，电子级，医药级" v-model="quality" readonly/>
                                </div>
                            </div>
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>索样有效期： </span>
                                </div>
                                <div class="zsxq-right zsxq-date">
                                    <input type="text" placeholder="开始时间" name="startDate" readonly v-model="startDate"> <i>-</i> <input type="text" placeholder="结束时间" name="endDate" readonly v-model="endDate">
                                </div>
                            </div>
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>产品信息： </span>
                                </div>
                                <div class="zsxq-right">
                                    <label class="dxk">
                                        <input type="radio" name="supply" checked="checked" @change="fileTypeChange(2)" />
                                        产品文档</label>
                                    <label class="dxk">
                                        <input type="radio" name="supply" @change="fileTypeChange(1)" />
                                        产品链接</label>
                                    <div v-show="fileType === 2">
                                        <div class="layui-input-block file-div">
                                            <div class="file-pdf-div">
                                                <div class="pdf-box">
                                                    <input class="file-pdf" type="file" @change="pdfUpload" />
                                                    <i>+点击上传<br /><span class="scjy">建议上传产品TDS或者MSDS文档</span></i>
                                                    <div class="explain">说明：支持pdf格式，文件小于50M</div>
                                                </div>
                                                <a id="tds" href="#" v-if="pdfFileName">{{ pdfFileName }}<div class="pdf-del" @click="removePdfFile">删除</div></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="fileType === 1">
                                        <input type="text" name="quality" placeholder="请输入产品链接" v-model="pdfLink" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="t" :class="{hover: keys[1]}" @click="blockToggle(1)"><i>拿样信息</i></div>
                        <div class="txt" v-show="!keys[1]">
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>拿样数量： </span>
                                </div>
                                <div class="zsxq-right">
                                    <input type="text" name="number" placeholder="请输入拿样数量" v-model="num" readonly/>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="t" :class="{hover: keys[2]}" @click="blockToggle(2)"><i>供应商信息</i></div>
                        <div class="txt" v-show="!keys[2]">
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>公司名称： </span>
                                </div>
                                <div class="zsxq-right">
                                    <input type="text" name="user_company" placeholder="请输入公司名称" v-model="companyName" readonly/>
                                </div>
                            </div>
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>联系人： </span>
                                </div>
                                <div class="zsxq-right">
                                    <input type="text" name="user_linkman" placeholder="请输入联系人" v-model="contact"/>
                                </div>
                            </div>
                            <div class="zsxq-list">
                                <div class="zsxq-left">
                                    <span><code>*</code>联系电话： </span>
                                </div>
                                <div class="zsxq-right">
                                    <input type="text" name="user_tel" placeholder="请输入联系电话" v-model="phone"/>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </form>
            <div class="sybtn">
                <button class="sc-qr add_sample" @click="submitAction">保存</button>
                <button class="sc-qx" @click="closePage">关闭</button>
            </div>
        </div>
    </div>
    <Loading text="文件上传中..." :visible="loadingVisible" />
</div>
</template>

  
<script>
import { uploadFile } from '../../http/upload'
import Loading from '../../components/ui/loader.vue'
import config from '../../common/config.js'
import axios from 'axios'
import qs from 'qs'
import utils from '../../common/utils'

export default {
    data() {
        return {
            id: this.$route.query.id,
            loadingVisible: false,
            keys: [ false, false, false ],
            fileType: 2,
            goodsName: '',
            application: '',
            quality: '',
            num: '',
            companyName: '',
            companyId: '',
            contact: '',
            phone: '',
            pdfFile: '',
            pdfFileName: '',
            startDate: '',
            endDate: '',
            pdfLink: ''
        }
    },
    mounted() {
        this.getData()
        this.getUserInfo()
        this.record()
    },
    components: {
        Loading
    },
    methods: {
        async record() {
            await axios.get(config.MallApi + 'api/wshop/sample/amount-pv?sampleId=' + this.id)
        },
        async getData() { 
            const r = await axios.get(config.MallApi + 'api/wshop/sample/sample-details?sampleId=' + this.id)
            const d = r.data.data
            if (r.data.error_code === 0) { 
                this.goodsName = d.goods_name
                this.startDate = d.indate_st
                this.endDate = d.indate_et
                this.application = d.application_area
                this.quality = d.quality
                this.num = d.number
                WeChatShare({
                    callback: function () {
                        var title = d.goods_name + '-优料库',
                            desc = '优料库样品中心帮助供配方工程师与原材料供应商进行技术对接，为配方师的性能需求提供符合要求的测试小样，同时供应商也根据已经发布的配方师需求进行供样对接。',
                            imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg';
                        wx.onMenuShareAppMessage({
                            title: title,
                            desc: desc,
                            link: window.location.href,
                            imgUrl: imgUrl
                        });
                        wx.onMenuShareTimeline({
                            title: title + " - " + desc,
                            link: window.location.href,
                            imgUrl: imgUrl
                        });
                    },
                    data: 'jsApiDomain=&url=' + encodeURIComponent(window.location.href),
                    url: config.MAPI
                })
            }
        },
        async getUserInfo() { 
            const r = await axios.get(config.MAPI + '/safety/account/get')
            const d = r.data.obj
            if (d && !d.companyId) {
                return window.location.href = `${config.USERAPI}mobile/uc/build/auth/component`
            }
            if (r.data.code === 1) {
                this.companyId = d.companyId
                this.companyName = d.company
                this.contact = d.name
                this.phone = d.mobile
            } else if (r.data.code === 100) { 
                window.location.href = `${config.USERAPI}mobile/uc/build/login/?returnUrl=${encodeURIComponent(encodeURIComponent(window.location.href))}`
            }
        },
        fileTypeChange(type) {
            this.fileType = type
        },
        blockToggle(index) { 
            this.keys.splice(index, 1, !this.keys[index])
        },
        closePage() { 
            this.$router.back()
        },
        async pdfUpload() { 
            const file = event.target.files[0]
            event.target.value = ''
            if (file.type !== 'application/pdf') { 
                this.$nToast.show('请上传pdf文件')
                return
            }
            if (file.size / 1024 > 1024 * 1024 * 50) { 
                this.$nToast.show('最大只能上传50M的文件')
                return
            }
            this.loadingVisible = true
            const r = await uploadFile(file)
            this.loadingVisible = false
            this.pdfFileName = file.name
            this.pdfFile = r.data.source
        },
        removePdfFile() { 
            this.pdfFile = ''
            this.pdfFileName = ''
        },
        async submitAction() { 
            // 如果没有企业认证
            if (this.companyId === '') { 
                return window.location.href = `${config.USERAPI}mobile/uc/build/auth/component`
            }
            if (this.fileType === 2 && this.pdfFile === '') { 
                return this.$nToast.show('请上传产品文档')
            }
            if (this.fileType === 1 && this.pdfLink === '') { 
                return this.$nToast.show('请填写产品链接')
            }
            if (this.contact === '') { 
                return this.$nToast.show('请填写联系人')
            }
            if (this.phone === '') { 
                return this.$nToast.show('请填写联系电话')
            }
            if (this.phone.length !== 11) { 
                return this.$nToast.show('请填写11位联系电话')
            }

            const r = await axios.post(`${config.MallApi}api/wshop/sample/add-offer`, qs.stringify({
                syxq: this.goodsName,
                application_area: this.application,
                quality: this.quality,
                supply:	"2",
                offer_sample_type: this.fileType,
                offer_pdf_url: this.pdfFile,
                offer_goods_url: this.pdfLink,
                number: this.number,
                company_linkman: this.contact,
                company_tel: this.phone,
                sample_id: this.id,
                company_id: this.companyId,
                api_token: utils.getCookie('CMALL_TOKEN')
            }))
            if (r.data.error_code === 0) {
                this.$nToast.show('提交成功')
            } else { 
                this.$nToast.show(r.data.msg)
            }
        }
    }
};
</script>

  
<style lang="less" scoped>
.pdf-box {
    width: 98%;
    text-align: center;
    border: 1px solid #e6e6e6;
    background-color: #f5f5f5;
    position: relative;
    padding: 0.8rem 0;
}

.pdf-box i {
    display: inline-block;
    font-size: 1.5rem;
    line-height: 2rem;
    font-style: normal;
}

.pdf-box input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.scjy {
    color: red;
    font-size: 1rem;
}

.explain {
    height: 1.5rem;
    color: #999;
    line-height: 1.5rem;
    font-size: 1rem;
}
#tds {
    display: block;
    line-height: 1.5rem;
    color: #333 !important;
    display: flex;
    align-items: center;
    margin-top: 10px;
}
.pdf-del {
    color: red;
    cursor: pointer;
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/demo/form.vue